export const getSelectionCoordinates = (ref, selectionRange) => {
    if (!ref) {
        return null;
    }

    const editorBounds = ref.getBoundingClientRect();
    const rangeBounds = selectionRange.getBoundingClientRect();
    const rangeWidth = rangeBounds.right - rangeBounds.left;
    const left = (rangeBounds.left - editorBounds.left) + (rangeWidth / 2) + editorBounds.x;
    const top = rangeBounds.top - editorBounds.top - 50 + editorBounds.y;
    return {left, top};
};



// WEBPACK FOOTER //
// ./src/components/controls/RichEditor/utils/getSelectionCoordinates.js